var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { ChartComponent, chartDefaults, defaultTooltipProps, gridColor, } from "../chart/ChartComponent";
import { getBackGroundPlugin, getDataSets } from "../utils";
export const Pie = forwardRef((_a, ref) => {
    var { background = "white", responsive, data, title, titlePosition, legendPosition, hoverBorderColor, borderColor, borderWidth = 1, hoverBorderWidth = 2, tooltip, showLegend } = _a, rest = __rest(_a, ["background", "responsive", "data", "title", "titlePosition", "legendPosition", "hoverBorderColor", "borderColor", "borderWidth", "hoverBorderWidth", "tooltip", "showLegend"]);
    return (_jsx(ChartComponent, Object.assign({}, rest, { responsive: responsive, plugins: [getBackGroundPlugin(background)], options: {
            plugins: {
                title: Object.assign({}, chartDefaults(background, title, {
                    titlePosition,
                    legendPosition,
                }).title),
                legend: Object.assign(Object.assign({}, chartDefaults(background, title, {
                    titlePosition,
                    legendPosition,
                }).legend), { display: showLegend }),
                tooltip: Object.assign(Object.assign({}, defaultTooltipProps), tooltip),
            },
            scales: {
                x: {
                    grid: {
                        color: gridColor(background),
                        display: false,
                        // @ts-ignore
                        drawBorder: false,
                    },
                    ticks: {
                        display: false,
                    },
                },
                y: {
                    grid: {
                        color: gridColor(background),
                        display: false,
                        // @ts-ignore
                        drawBorder: false,
                    },
                    ticks: {
                        display: false,
                    },
                },
            },
            layout: {
                padding: { left: 10, top: 25, right: 30, bottom: 20 },
            },
        }, data: Object.assign(Object.assign({}, data), { datasets: (typeof data !== "function" ? data.datasets : []).map((e) => (Object.assign({ backgroundColor: getDataSets({
                    darkBackground: background !== "white",
                    data,
                }), borderWidth,
                hoverBorderWidth, borderColor: borderColor ||
                    (background === "black"
                        ? "#000000"
                        : background === "dark"
                            ? "#004673"
                            : "#ffffff"), hoverBorderColor: hoverBorderColor ||
                    (background === "black"
                        ? "#ffffff"
                        : background === "dark"
                            ? "#ffffff"
                            : "#000000") }, e))) }), type: "pie", ref: ref })));
});
Pie.displayName = "Pie";
